module.exports = __webpack_public_path__ + "static/media/nft-21.d17aead7.jpg";